import { AxiosResponse } from 'axios';

import client from '../../lib/service/publication.service';
import {
  CategoriesResponse,
  Category,
  CategoryResponse,
} from './categories.types';

const CATEGORIES = `/v1/categories`;
const CATEGORY = (categoryId: string) => `/v1/categories/${categoryId}`;

export async function getCategories(): Promise<Category[]> {
  const response = await client.get<null, AxiosResponse<CategoriesResponse>>(
    CATEGORIES,
  );
  return response.data.categories;
}

export async function getCategory(categoryId: string): Promise<Category> {
  const response = await client.get<null, AxiosResponse<CategoryResponse>>(
    CATEGORY(categoryId),
  );
  return response.data.category;
}

export async function postCategory(category: Category): Promise<Category[]> {
  const newCategory = { name: category.name };
  const response = await client.post<
    Category,
    AxiosResponse<CategoriesResponse>
  >(CATEGORIES, newCategory);
  return response.data.categories;
}

export async function updateCategory(category: Category): Promise<Category[]> {
  const response = await client.put<
    Category,
    AxiosResponse<CategoriesResponse>
  >(CATEGORY(category.id as string), category);
  return response.data.categories;
}

export async function deleteCategory(categoryId: string) {
  return await client.delete(CATEGORY(categoryId));
}
